
define('text!modules/creatives/concept/templates/createEditWarning.html',[],function () { return '{{#show}}\n<div class="form-stack info-box-holder column {{cssClasses}}">\n\t<div class="info-box error" style="display: block;">\n\t\t<i class="icon"></i>\n\t\t<div class="message">\n\t\t\t{{warningMessage}}\n\t\t</div>\n\t</div>\n</div>\n{{/show}}';});

